import { Breadcrumb, Button, Card, Col, Form, Input, Modal, Row, Switch, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import MongerlabCustomerService from "../../services/MongerlabCustomerService";
import { IMongerlabCustomerLookup } from "../../types/MongerlabCustomer";
import { openNotification, can } from "../../utils";
import SettingsRouter from "./SettingsRouter";

const { Title } = Typography;

export const MongerlabCustomerAppStatusSettings = () => {
  const canUpdate = can("mongerlab-customer-app-statuses:update");
  const canView = can("mongerlab-customer-app-statuses:getAll") || canUpdate;
  const [items, setItems] = useState<IMongerlabCustomerLookup[]>([]);
  const [loading, setLoading] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editing, setEditing] = useState<IMongerlabCustomerLookup | null>(null);
  const [editForm] = Form.useForm();

  const load = () => {
    if (!canView) return;
    setLoading(true);
    MongerlabCustomerService.getAppStatuses()
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [canView]);

  const columns: ColumnsType<IMongerlabCustomerLookup> = [
    { title: "ID", dataIndex: "id", key: "id", width: 80 },
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (_, row) =>
        canUpdate ? (
          <Switch
            checked={row.active}
            onChange={(checked) =>
              MongerlabCustomerService.updateAppStatus(row.id, { active: checked }).then(load)
            }
          />
        ) : row.active ? (
          "Yes"
        ) : (
          "No"
        ),
    },
    ...(canUpdate
      ? [
          {
            title: "Actions",
            key: "actions",
            render: (_: unknown, row: IMongerlabCustomerLookup) => (
              <Button
                size="small"
                onClick={() => {
                  setEditing(row);
                  editForm.setFieldsValue({ name: row.name });
                  setEditModalOpen(true);
                }}
              >
                Edit
              </Button>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <Breadcrumb items={[{ title: <NavLink to="/settings">Settings</NavLink> }, { title: "Mongerlab App Status" }]} />
      <SettingsRouter />
      <Row style={{ margin: "16px 0" }}>
        <Col>
          <Title level={4}>Mongerlab App Status</Title>
        </Col>
      </Row>
      <Card>
        <Table rowKey="id" loading={loading} columns={columns} dataSource={items} pagination={false} />
      </Card>

      <Modal title="Edit App Status" open={editModalOpen} onCancel={() => setEditModalOpen(false)} onOk={() => editForm.submit()}>
        <Form
          form={editForm}
          layout="vertical"
          onFinish={(values) =>
            MongerlabCustomerService.updateAppStatus(editing!.id, values).then(() => {
              openNotification("success", "Success", "App status updated");
              setEditModalOpen(false);
              load();
            })
          }
        >
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default MongerlabCustomerAppStatusSettings;
